<template>
  <sc-page-base
    :title="title"
    :loading="loading">
    <section v-if="lote">
      <sc-logs-tracking-lote-detail-header />

      <div class="box">
        <sc-tabs>
          <sc-tab-item label="Histórico">
            <tab-logs-tracking-lote-detail-history />
          </sc-tab-item>

          <sc-tab-item label="Eventos">
            <tab-logs-tracking-lote-detail-event />
          </sc-tab-item>
        </sc-tabs>
      </div>
    </section>
  </sc-page-base>
</template>

<script>
  import {
    ScPageBase,
    ScTabs,
    ScTabItem,
  } from '@intelipost-js/secure-components';
  import { createNamespacedHelpers } from 'vuex';
  import ScLogsTrackingLoteDetailHeader from './components/sc-logs-tracking-lote-detail-header/ScLogsTrackingLoteDetailHeader';
  import TabLogsTrackingLoteDetailHistory from './tabs/tab-logs-tracking-lote-detail-history/TabLogsTrackingLoteDetailHistory';
  import TabLogsTrackingLoteDetailEvent from './tabs/tab-logs-tracking-lote-detail-event/TabLogsTrackingLoteDetailEvent';

  const { mapState, mapActions } = createNamespacedHelpers('analytic/logsTracking');

  export default {
    name: 'page-logs-tracking-lote-detail',
    computed: {
      title() {
        const { id } = this.$route.params;
        return `Lote ${id}`;
      },
      ...mapState([
        'loading',
        'lote',
      ]),
    },
    methods: {
      ...mapActions([
        'getLote',
      ]),
      backToLogs() {
        this.$router.push({
          name: 'logs-tracking',
        });
      },
    },
    beforeMount() {
      const { id } = this.$route.params;

      if (id) {
        this.getLote(id)
          .catch(() => this.backToLogs());
      } else {
        this.backToLogs();
      }
    },
    components: {
      ScPageBase,
      ScTabs,
      ScTabItem,
      ScLogsTrackingLoteDetailHeader,
      TabLogsTrackingLoteDetailHistory,
      TabLogsTrackingLoteDetailEvent,
    },
  };
</script>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-analytic/features/logs/pages/tracking/pages/logs-tracking-lote-detail/PageLogsTrackingLoteDetail.vue?3e3abefe